import {config} from '../config';
import {TConfigGetterReturn} from './types';

export default {
    getIsUsageAvailableP1: (): TConfigGetterReturn<boolean> => config.data.usage.isUsageAvailableP1,
    getIsUsageAvailableAriane: (): TConfigGetterReturn<boolean> => config.data.usage.isUsageAvailableAriane,
    getIsUsageAvailableP4: (): TConfigGetterReturn<boolean> => config.data.usage.isUsageAvailableP4,
    getIsUsageAvailableP1V4: (): TConfigGetterReturn<boolean> => config.data.usage.isUsageAvailableP1V4,
    getIsFirstDaySunday: (): TConfigGetterReturn<boolean> => config.data.usage.isFirstDaySunday,
    getIs12HoursToggleEnabled: (): TConfigGetterReturn<boolean> => config.data.usage.is12HoursToggleEnabled,
    getIsNbw2UsageEnabled: (): TConfigGetterReturn<boolean> => config.data.usage.isNbw2UsageEnabled,
    getMaximumTimeDeltaInS: (): TConfigGetterReturn<number> =>
        config.data.usage.maximumTimeDeltaInS === undefined ? 120 : config.data.usage.maximumTimeDeltaInS,
};
